<template>
	<div class="card bouton">
		<a v-if="bouton.url" :href="bouton.url" target="_blank"></a>
		<router-link v-else :to="{name:'Offre',params:{support:currentSupport.slug,bouton:bouton.slug}}"></router-link>
		<div class="card-image">
			<figure class="image is-4by3">
				<img :src="illustration" alt="Placeholder image">
			</figure>
		</div>
		<div class="card-content">
			<div class="media">
				<div class="media-content">
					<p class="title is-4">{{bouton.titre}}</p>
					<p class="subtitle is-6">{{currentSupport.nom}}</p>
				</div>
			</div>

			<div class="content">{{bouton.description | striphtml }}</div>
		</div>
	</div>
	
</template>
<script>
	export default {
		props : ['bouton'],
		computed : {
			illustration() {
				if(this.bouton.illustration) {
					return this.bouton.illustration;
				} else {
					return this.currentSupport.logoSvgUrl;
				}
			}
		},
		methods : {
			lancerBouton() {
				alert('oui')
			}
		}
	}
</script>

<style lang="scss">
.bouton {
	figure img {
		object-fit: contain;
	}
	a {
		background-color: white;
		opacity: 0.3;
		width: 100%;
		height: 100%;
		position: absolute;
		z-index: 1;
		transition: opacity .2s ease;
		cursor: pointer;
		&:hover {
			opacity: 0;
		}
	}
}
</style>